import { isNil } from '~/utilities/type-guards';

export const getLocalStorage = (key: string): unknown => {
  const value = window.localStorage.getItem(key);
  if (isNil(value)) {
    return null;
  }
  return JSON.parse(value);
};

export const setLocalStorage = (key: string, value: unknown): void => {
  window.localStorage.setItem(key, JSON.stringify(value));
};
